module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0110.jpg?v=eaeeb6e0";